export const AQUARIST_URL = 'https://midnightswim.app/aquarist'
